import React, { useEffect, useState } from "react";
import GlobalWrapper from "../../components/Wrapper/GlobalWrapper";
import { Box, Button } from "@mui/material";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import FromAndToDatePicker from "../../components/mui/FromAndToDatePicker";
import dayjs from "dayjs";
import GlobalMultiSelectNew from "../../components/mui/GlobalMultiSelectNew";
import GlobalDatagrid from "../../components/mui/DataGrid/GlobalDatagrid";
import { useLocation, useNavigate } from "react-router-dom";
import ToolTip from "../../components/ToolTip/ToolTip";
import { getTaTutorData } from "../../redux/features/srtSlice";

const SrtTaView = () => {
  const userProfile = JSON.parse(localStorage.getItem("cred")).profile;

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const taID = userProfile.roleID;
  const project_id = searchParams.get("projectId");
  const fromdate = searchParams.get("fromDate");
  const todate = searchParams.get("toDate");

  const { paginationData } = useSelector((state) => state.globalDataGrid);
  const { gridSize, pageNum, rowData, openAnchor, search } = paginationData;

  const [fromDate, setFromDate] = useState(
    fromdate || dayjs().startOf("month").format("YYYY-MM-DD")
  );
  const [toDate, setToDate] = useState(
    todate || dayjs().endOf("month").format("YYYY-MM-DD")
  );

  const [selectedTutor, setSelectedTutor] = useState([]);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { tutordata, loading } = useSelector((state) => state.srt);

  const GridHead = [
    { field: "full_name", headerName: "Tutor Name", width: 200 },
    {
      field: "rescheduled_count",
      headerName: "Rescheduled Sessions",
      width: 200,
    },
    {
      field: "rescheduled_by_parent",
      headerName: "Parent Issue",
      width: 200,
    },
    {
      field: "rescheduled_by_tutor",
      headerName: "Tutor Issue",
      width: 200,
    },
    {
      field: "action",
      headerName: "Action",
      width: 200,
      renderCell: (params) => {
        return (
          <Button
            sx={{
              background:
                "linear-gradient(135deg, rgb(62, 72, 106), rgb(134, 105, 241))",
              color: "#fff",
              "&:hover": {
                background:
                  "linear-gradient(135deg, rgba(0, 139, 208, 0.79), rgba(62, 108, 177, 0.74))",
              },
              px: "10px",
            }}
            onClick={() => {
              navigate(
                `/my-workspace/srt-tastudentdetails?fromDate=${fromDate}&toDate=${toDate}&trainer_id=${params.row.trainer_id}&project_id=${project_id}`
              );
            }}
          >
            View Report
          </Button>
        );
      },
    },
  ];

  useEffect(() => {
    dispatch(
      getTaTutorData({
        page: pageNum,
        limit: gridSize,
        projectId: project_id,
        fromDate: fromDate,
        toDate: toDate,
      })
    );
  }, [fromdate, todate, project_id, pageNum, gridSize, dispatch]);

  return (
    <GlobalWrapper title={"Student Details"}>
      <Box sx={{ display: "flex", mb: 1, gap: "10px", flexDirection: "row" }}>
        <FromAndToDatePicker
          disabled={false}
          fromDate={fromDate}
          toDate={toDate}
          setFromDate={setFromDate}
          setToDate={setToDate}
        />
        {/* <GlobalMultiSelectNew
          disabled={loading}
          label={"Tutor"}
          arrayState={selectedTutor}
          arraySetState={setSelectedTutor}
          data={tutorslist}
          keys={{ id: "name", value: "name" }}
        /> */}
      </Box>
      <Box sx={{ width: "100%", padding: 0 }}>
        <GlobalDatagrid
          tableHead={GridHead}
          rows={tutordata.data}
          meta={tutordata?.meta?.totalRecords || 0}
          rowUniqueId="trainer_id"
          loading={loading}
          rowClick={false}
        />
      </Box>
    </GlobalWrapper>
  );
};

export default SrtTaView;
